import React from "react";
import { Text13, Text2, Text3, TextTitleCard } from "./styles";
import { useApp } from "../../contexts";
import { formatMoney } from "../../utils/hepler";
import { replaceString } from "../../utils/helper";
import { UserGroup2Icon } from "../Icons/UserGroup2Icon";
import { ArrowRightCircle } from "../Icons/ArrowRightCircle";
import { isNil } from "lodash";

export const CardAffiliate2 = ({ style, data }) => {
  const { T, language } = useApp();

  const isNoRank =
    !data?.team_affiliate_rank || data?.team_affiliate_rank === "no_rank";
  return (
    <div
      className="bg-[#25292E] rounded-xl px-[24px] h-full py-[35px]"
      style={style}
    >
      <div className="flex justify-between">
        <TextTitleCard>{T("Team Affiliate Rank")}</TextTitleCard>
      </div>
      <div className="mt-4">
        <Text2>{isNoRank ? T("No rank") : data?.team_affiliate_rank}</Text2>
      </div>
      {!isNil(data?.team_affiliate_need_amount) && (
        <div className="mt-2 lg:mt-6">
          <Text2
            dangerouslySetInnerHTML={{
              __html: `${replaceString(
                T(
                  "Earn {amount} and achieve more milestones for your next rank"
                ),
                "{amount}",
                `<span class="money">$${formatMoney(
                  +(data?.team_affiliate_need_amount ?? 0),
                  0
                )}+</span>`
              )}`,
            }}
          />
        </div>
      )}

      <div className="flex justify-between mt-9">
        <div className="flex flex-col gap-2">
          <Text2>{T("Left Leg")}</Text2>
          <Text13 className="flex items-center gap-3">
            {data?.left_count ?? 0}
            <UserGroup2Icon />
          </Text13>
        </div>

        <div className="flex flex-col gap-2">
          <Text2>{T("Right Leg")}</Text2>
          <Text13 className="flex items-center gap-3">
            {data?.right_count ?? 0}
            <UserGroup2Icon />
          </Text13>
        </div>
      </div>
    </div>
  );
};
